import { render, staticRenderFns } from "./EditUserContent.vue?vue&type=template&id=bfbb57dc&"
import script from "./EditUserContent.vue?vue&type=script&lang=ts&"
export * from "./EditUserContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports